import React from "react";
import resume from "../assets/BillieZhangResume.pdf";

const ExperienceItem = ({ position, company, time, focus }) => {
  return (
    <div className="border-t border-border py-10 md:grid md:grid-cols-12 gap-4 items-center group transition-all duration-500 hover:bg-secondary/5">

      <div className="md:col-span-3 mb-2 md:mb-0">
        <span className="text-xs font-bold uppercase tracking-widest text-secondary/40">
          {time}
        </span>
      </div>

      <div className="md:col-span-5 flex flex-col">
        <h3 className="text-2xl md:text-3xl font-semibold tracking-tight text-text group-hover:text-secondary transition-colors duration-300">
          {position}
        </h3>
        <p className="text-secondary font-medium leading-relaxed text-md mt-2">
          {company}
        </p>
      </div>

      <div className="md:col-span-4 flex flex-wrap md:justify-end gap-2 mt-4 md:mt-0">
        {focus.map((item, i) => (
          <span
            key={i}
            className="text-[9px] md:text-[10px] uppercase tracking-wider font-bold px-3 py-1.5 border border-border rounded-full text-secondary/70 group-hover:border-accent/30 group-hover:text-text transition-all duration-500"
          >
            {item}
          </span>
        ))}
      </div>
    </div>
  );
};

const Experience = () => {
  const experiences = [
    {
      position: "technical product manager",
      company: "Versaterm",
      time: "MAY - AUG 2026",
      focus: ["Vue.js", "Spring Boot", "Claude Code"],
    },
    {
      position: "product manager",
      company: "Collective Impact Labs",
      time: "OCT 2025 - FEB 2026",
      focus: [""],
    },
    {
      position: "software engineer",
      company: "Dyna Software Inc",
      time: "SEPT - DEC 2025",
      focus: ["Typescript", "Python"],
    },

    {
      position: "software engineer",
      company: "Versaterm",
      time: "JAN - APR 2025",
      focus: ["Vue.js", "Spring Boot", "Hibernate"],
    },
    {
      position: "technical product manager",
      company: "Develop for Good",
      time: "JUN 2024 - JAN 2025",
      focus: ["React Native", "Agile", "Strategy"],
    },
    {
      position: "software engineer",
      company: "CW3",
      time: "JUN - DEC 2024",
      focus: ["TypeScript", "React", "AppWrite"],
    },
    {
      position: "software engineer",
      company: "Omniscient Neurotechnology",
      time: "MAY - AUG 2024",
      focus: ["Playwright", "Typescript"],
    },
    {
      position: "front end developer",
      company: "RBC",
      time: "SEPT - DEC 2023",
      focus: ["TypeScript"],
    }
  ];

  return (
    <section id="experience" className="py-32 bg-background">
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-end mb-16">
          <div className="space-y-2">
            <h2 className="text-sm uppercase tracking-[0.5em] text-secondary font-bold ml-2">
              real world
            </h2>
            <h3 className="text-5xl md:text-6xl font-bold tracking-tighter text-text">
              experience.
            </h3>
          </div>
          <a
            href={resume}
            target="_blank" rel="noreferrer"
            className="text-xs uppercase tracking-widest font-bold text-secondary hover:text-text transition-colors mt-4 md:mt-0 border-b border-border pb-1"
          >
            see Full CV
          </a>
        </div>

        <div className="flex flex-col">
          {experiences.map((exp, index) => (
            <ExperienceItem key={index} {...exp} />
          ))}
          <div className="border-t border-border"></div>
        </div>

      </div>
    </section>
  );
};

export default Experience;